import React from 'react';
import PropTypes from 'prop-types';

class FieldValidationWarning extends React.Component {
  static propTypes = {
    warning: PropTypes.string,
  }

  static defaultProps = {
    warning: null,
  }

  render() {
    const { warning } = this.props;
    if (warning) {
      return (
        <div className="required-alert">
          <div className="required-alert__badge animate__animated animate__fadeIn">
            <i className="fas fa-exclamation-triangle" />
            {this.props.warning}
          </div>
        </div>
      );
    }
    return '';
  }
}

export default FieldValidationWarning;
